<div class="h-[calc(100dvh-4rem)] md:pl-16 flex flex-col">
  <div class="hidden md:block">
    <app-status-bar />
  </div>
  <!-- <p-menu #menu [model]="selectedMenuItems()" [popup]="true" /> -->
  <div class="flex flex-col mt-6 md:mt-12">
    <p-tabs value="entidades" scrollable>
      <p-tablist>
        @if (perm.hasPermission(RECURSOS.VER_CONFIGURACION)) {
        <p-tab value="entidades" routerLink="entidades" class="flex items-center !gap-2 text-inherit">
          <i class="pi pi-building"></i>
          <span class="text-xs md:text-base">Entidades</span>
        </p-tab>
        <p-tab value="usuarios" routerLink="usuarios" class="flex items-center !gap-2 text-inherit">
          <i class="pi pi-user"></i>
          <span class="text-xs md:text-base">Usuarios</span>
        </p-tab>
        }
        @if (perm.hasPermission(RECURSOS.VER_CONFIGURACION) && perm.hasPermission(RECURSOS.INGRESO_MODULO_MEDICAMENTOS)) {
        <p-tab value="medicamentos" routerLink="medicamentos" class="flex items-center !gap-2 text-inherit">
          <i class="pi pi-list"></i>
          <span class="text-xs md:text-base">Medicamentos</span>
        </p-tab>
        }
        @if (perm.hasPermission(RECURSOS.VER_CONFIGURACION)) {
        <p-tab routerLink="app_config" value="app_config" class="flex items-center !gap-2 text-inherit">
          <i class="pi pi-sliders-h"></i>
          <span class="text-xs md:text-base">Sistema</span>
        </p-tab>
        <p-tab routerLink="reportes" value="reportes" class="flex items-center !gap-2 text-inherit">
          <i class="pi pi-file-excel"></i>
          <span class="text-xs md:text-base">Reportes</span>
        </p-tab>
        }
        @if (perm.hasAnyPermission(RECURSOS_PANEL_ALERTAS)) {
        <p-tab routerLink="alertas" value="alertas" class="flex items-center !gap-2 text-inherit">
          <i class="pi pi-flag"></i>
          <span class="text-xs md:text-base">Alertas</span>
        </p-tab>
        }
        @if (perm.isSystemAdmin()) {
        <p-tab routerLink="herramientas" value="herramientas" class="flex items-center !gap-2 text-inherit">
          <i class="pi pi-wrench"></i>
          <span class="text-xs md:text-base">Herramientas</span>
        </p-tab>
        }
      </p-tablist>
    </p-tabs>
    <router-outlet></router-outlet>
  </div>
</div>
<app-nav-bar />
